export default "/images/vendor/flag-icon-css/flags/1x1/pw.svg?666cd05f03955ea01aa5859d914a0fa1";